import { render, staticRenderFns } from "./componentsA.vue?vue&type=template&id=d2ca4b22&scoped=true&"
import script from "./componentsA.vue?vue&type=script&lang=js&"
export * from "./componentsA.vue?vue&type=script&lang=js&"
import style0 from "./componentsA.vue?vue&type=style&index=0&id=d2ca4b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ca4b22",
  null
  
)

export default component.exports